import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import ReportAttendance_Settings from "./settings";
import {ReportConfig} from "../../../@types";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportAttendance extends Report<ReportAttendance_Settings> {

    static reportName   : string = "Attendance report"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_ATTENDANCE
        super(data);

        this.icon        = "isvg-attendance"
        this.description = "Displays daily work hours based on check-in and check-out data, providing a clear record of attendance and time spent at work."

        this.settings    = new ReportAttendance_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportAttendance {
        return new ReportAttendance(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportAttendance_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
